module.exports = __webpack_public_path__ + "static/media/walking.25bc895d.svg";